// Field — labelled form control with unit + helper + validation (Blueprint §4.6 / D-30).
// Replaces bare placeholder-only inputs in the operator console.

import type { InputHTMLAttributes, ReactNode } from "react";

export function Field({
  label,
  unit,
  helper,
  error,
  children,
}: {
  label: string;
  unit?: string;
  helper?: string;
  error?: string;
  children: ReactNode;
}) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-bold uppercase tracking-wide text-slate-500">
        {label}
        {unit ? <span className="ml-1 text-slate-400">({unit})</span> : null}
      </span>
      {children}
      {error ? (
        <span className="text-[11px] font-semibold text-red-600">{error}</span>
      ) : helper ? (
        <span className="text-[11px] text-slate-400">{helper}</span>
      ) : null}
    </label>
  );
}

export function TextInput(props: InputHTMLAttributes<HTMLInputElement>) {
  const { className = "", ...rest } = props;
  return (
    <input
      {...rest}
      className={`rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-200 ${className}`}
    />
  );
}
